import {Component, inject, OnDestroy} from '@angular/core';
import {NgClass, NgStyle} from "@angular/common";
import {Slide} from '../../../models/slider.model';
import {SsrService} from '../../../../core/ssr/services/ssr.service';

@Component({
  selector: 'app-slider',
  standalone: true,
  imports: [
    NgStyle,
    NgClass
  ],
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.scss'
})
export class SliderComponent implements OnDestroy {
  slides: Slide[] = [{
    title: "slide 1",
    color: "#477b99",
    imageDesktop: "sliders/slider-suivez-nous.png",
    imageMobile: "sliders/slider-suivez-nous-mobile.png",
  }, {
    title: "slide 1",
    color: "#477b99",
    imageDesktop: "sliders/slider-suivez-nous.png",
    imageMobile: "sliders/slider-suivez-nous-mobile.png",
  }];

  currentSlideIndex: number = 0;
  intervalId: any;

  private readonly ssrService: SsrService = inject(SsrService);

  constructor() {
    if (this.ssrService.isClientSide) this.unsafeStartSlider();
  }

  ngOnDestroy(): void {
    if (this.ssrService.isClientSide) clearInterval(this.intervalId);
  }

  onPrevSlide(): void {
    if (this.ssrService.isClientSide) this.unsafeOnPrevSlide();
  }

  onNextSlide(): void {
    if (this.ssrService.isClientSide) this.unsafeOnNextSlide();
  }

  onSelectedSlide(index: number) {
    if (this.ssrService.isClientSide) {
      console.log("ici");
      this.unsafeOnSelectedSlide(index);
    }
  }

  private unsafeOnPrevSlide(): void {
    const nextIndex = this.currentSlideIndex === 0 ? this.slides.length - 1 : this.currentSlideIndex - 1;
    this.onSelectedSlide(nextIndex);
  }

  private unsafeOnNextSlide(): void {
    const nextIndex = (this.currentSlideIndex + 1) % this.slides.length;
    this.onSelectedSlide(nextIndex);
  }

  private unsafeOnSelectedSlide(index: number) {
    this.unsafeResetSlides();
    this.currentSlideIndex = index;
  }

  private unsafeResetSlides(): void {
    clearInterval(this.intervalId);
    this.unsafeStartSlider();
  }

  private unsafeStartSlider(): void {
    this.intervalId = setInterval(() => {
      this.currentSlideIndex = (this.currentSlideIndex + 1) % this.slides.length;
    }, 5_000);
  }
}
